import { render, staticRenderFns } from "./friendWelcome.vue?vue&type=template&id=68d657f4&scoped=true&"
import script from "./friendWelcome.vue?vue&type=script&lang=js&"
export * from "./friendWelcome.vue?vue&type=script&lang=js&"
import style0 from "./friendWelcome.vue?vue&type=style&index=0&id=68d657f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d657f4",
  null
  
)

export default component.exports